// ═══════════════════════════════════════════════════════════════
// FolderTemplateV2Button.tsx – „Üres közzétételi dokumentum sablonok (ZIP)” letöltése
//
// A 2026-os központi mappaszerkezet, a pontok mappáiban a superadmin által a központi
// mintadokumentum-tárba feltöltött sablonfájlokkal (TemplateSamplesManager), kiegészítve az esetleges
// élő forrás-szervezet csatolmányaival. Bárki letöltheti, ha van tartalma; a tárat csak a superadmin kezeli.
// ═══════════════════════════════════════════════════════════════
import React, { useEffect, useState } from 'react';
import { ApiClient } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { Download, RefreshCw, FileStack } from 'lucide-react';

export const FolderTemplateV2Button: React.FC<{ refreshKey?: number }> = ({ refreshKey }) => {
  const { role } = useAuth();
  const isSuper = String(role) === 'superadmin';
  const [cfg, setCfg] = useState<Awaited<ReturnType<typeof ApiClient.getFolderTemplateV2>>['data'] | null>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    ApiClient.getFolderTemplateV2().then((r) => { if (r?.ok && r.data) setCfg(r.data); }).catch(() => {});
  }, [refreshKey]);

  const download = async () => {
    setBusy(true); setMsg(null);
    try { await ApiClient.downloadFolderTemplateZip({ blank: true, variant: 'v2' }); }
    catch (e: any) { setMsg(e.message || 'A letöltés nem sikerült'); }
    setBusy(false);
  };

  if (!cfg) return null;
  const n = (cfg.samples?.files || 0) + (cfg.stats?.files || 0);
  if (!cfg.configured) {
    return isSuper ? (
      <span className="px-3.5 py-2.5 rounded-xl border border-dashed border-emerald-400 text-emerald-700 dark:text-emerald-300 text-xs font-semibold flex items-center gap-2" title="Töltsön fel mintafájlokat a lenti központi tárba">
        <FileStack className="w-4 h-4" /> Üres közzétételi dokumentum sablonok – még nincs mintafájl
      </span>
    ) : null;
  }
  return (
    <span className="inline-flex items-center gap-1">
      <button type="button" onClick={download} disabled={busy}
        className="px-3.5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs shadow-md transition flex items-center gap-2 cursor-pointer disabled:opacity-50"
        title={`A 2026-os mappaszerkezet a pontokhoz tartozó minta sablonfájlokkal (${n} fájl)`}>
        {busy ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
        <span>Üres közzétételi dokumentum sablonok (ZIP)</span>
      </button>
      {msg && <span role="status" className="text-[11px] text-rose-600 dark:text-rose-400 ml-1">{msg}</span>}
    </span>
  );
};

export default FolderTemplateV2Button;
